import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import moment from 'moment';

import { 
  UPLOADED_FILES_TABLE_SECTION_I18N_KEYS as MY_I18N_KEYS, 
  UPLOADED_FILES_TABLE_SECTION_I18N_PREFIX as MY_I18N_PREFIX 
} from '../constants/i18n/UploadedFilesTableSectioni18nConstants';
import { DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT } from '../../../shared-components/chart/constants/eventLabellingChartConstants';
import {
  E_PLUS_TWO,
  E_MINUS_TWO
} from '../../../home/redux/constants';


class UploadedFilesTableSection extends Component {
  static propTypes = {
    allUploadedData: PropTypes.array.isRequired
  };

  getI18nText(textKey, params = {}) {
    return t(`${MY_I18N_PREFIX}.${textKey}`, params);
  }

  formatDate = (date) => {
    return moment(date, DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT).format("DD MMM YYYY");
  }

  convertLanguage = (language) => {
    const languageMap = {
      english: 'EN',
      simplified_chinese: 'ZH',
      malay: 'MS',
      bahasa_indonesia: 'ID'
    };

    return languageMap[language] || language;
  };

  roundFileSizeToTwoDecimalPlaces = (fileSize) => {
    let roundedFileSize = +(Math.round(parseFloat(fileSize + E_PLUS_TWO)) + E_MINUS_TWO);
    return roundedFileSize;
  }

  render() {
    const { allUploadedData } = this.props;
    const numberOfUploadedFiles = allUploadedData.length;

    return (
      <div className="uploaded-files-section">
        <div className="uploaded-files-body">
          <div className='uploaded-files-header'>
            <span>{this.getI18nText(MY_I18N_KEYS.title)}</span>
            <span className="uploaded-files-count">
              {numberOfUploadedFiles} file{numberOfUploadedFiles !== 1 ? 's' : ''} uploaded
            </span>
          </div>
          <div className="uploaded-files-table">
            <table>
              <thead>
                <tr>
                  <th>{this.getI18nText(MY_I18N_KEYS.file_name)}</th>
                  <th>{this.getI18nText(MY_I18N_KEYS.file_size)}</th>
                  <th>{this.getI18nText(MY_I18N_KEYS.file_language)}</th>
                  <th>{this.getI18nText(MY_I18N_KEYS.file_date_uploaded)}</th>
                  <th>{this.getI18nText(MY_I18N_KEYS.file_status)}</th>
                </tr>
              </thead>
              <tbody>
                {allUploadedData.map((file) => (
                  <tr key={file.fileName}>
                    <td>{file.fileName}</td>
                    <td>{this.getI18nText(MY_I18N_KEYS.kb_label, { fileSizeInKB: this.roundFileSizeToTwoDecimalPlaces(file.size) })}</td>
                    <td>{this.convertLanguage(file.language)}</td>
                    <td>{this.formatDate(file.dateUploaded)}</td>
                    <td>{file.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default UploadedFilesTableSection;


// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/UploadedFilesTableSection.js